module.exports = __webpack_public_path__ + "img/bowel-screening.35491d12.jpg";